module.exports = {
  menus: [
    {
      label: "b005 注文一覧",
      to: { name: "b005" },
      name: "b005",
    },
    {
      label: "定型メッセージ一覧",
      to: { name: "b120" },
      name: "b120",
    },
    {
      label: "クーポン一覧",
      to: { name: "b045" },
      name: "b045",
    },
    {
      label: "不達メール一覧",
      to: { name: "b090" },
      name: "b090",
    },
  ],
  reset_pass: {
    url_expried: 1800,
    cookie_key: "reset_pass_url_expried_cookie_key",
    allow: "b020",
    deny: "b015",
  },
  localstorage_key: "app",
};
